import React, { useState } from "react";
import { Home, User, Settings, Menu, LayoutDashboardIcon } from "lucide-react";
import { NavLink } from "react-router-dom";

export default function Sidebar({ open, setOpen }) {
  const links = [
    { to: "/dashboard", label: "Dashboard", icon: <LayoutDashboardIcon size={18} /> },
    { to: "/", label: "Home", icon: <Home size={18} /> },
    { to: "/profile", label: "Profile", icon: <User size={18} /> },
    { to: "/settings", label: "Settings", icon: <Settings size={18} /> },
  ];

  return (
    <div
      className={`fixed top-0 left-0 h-screen bg-gray-900 text-gray-100 flex flex-col transition-all duration-300 ${
        open ? "w-64" : "w-20"
      }`}
    >
      {/* Sidebar Header */}
      <div className="flex items-center justify-between p-4">
        {open && <span className="font-bold text-lg">MyApp</span>}
        <Menu
          className="cursor-pointer"
          size={20}
          onClick={() => setOpen(!open)}
        />
      </div>

      {/* Nav Links */}
      <nav className="flex-1 mt-4">
        {links.map((link) => (
          <NavLink
            key={link.to}
            to={link.to}
            className={({ isActive }) =>
              `flex items-center gap-3 px-4 py-2 text-sm rounded-md transition-colors
              ${isActive ? "bg-teal-600 text-white" : "hover:bg-gray-700"}`
            }
          >
            {link.icon}
            <span
              className={`whitespace-nowrap transition-all duration-200 ${
                !open ? "opacity-0 w-0 overflow-hidden" : "opacity-100 w-auto"
              }`}
            >
              {link.label}
            </span>
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
